/**
 * Literal brand colour values.
 *
 * The design system is tokens (CSS variables surfaced as Tailwind utilities), and components must not
 * carry bare hex. A handful of contexts, though, need a colour STRING rather than a class: a QR code's
 * foreground and background are drawn to canvas/SVG and take a literal. Those literals live here, once,
 * so no component holds a raw hex and the token guard has a single sanctioned home for them.
 *
 * A QR is deliberately dark-pine on white in BOTH themes, because a QR needs high contrast to scan and
 * a "dark mode" QR is a QR a phone struggles to read.
 */
export const BRAND_PINE = '#00482D';
export const WHITE = '#FFFFFF';
